var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"my-0 mx-1",attrs:{"icon":"","href":_vm.url}},'v-btn',attrs,false),on),[_c('v-img',{attrs:{"src":require(("../assets/" + _vm.icon)),"contain":"","height":"30","width":"30"}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }